import isInIcestark from '@ice/stark-app/lib/isInIcestark'
import { store as iceStore, event as iceEvent } from '@ice/stark-data'
import util from '@/libs/util.js'
import { autoLogin } from '@/api/auth'
import store from '@/store/index'

const ICE_STORE_KEYS = {
  SCW_TOKEN: 'SCW_TOKEN_',
  SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE: 'SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE'
}

export const ICE_EVENT_NAMES = {
  EXIT_GOODS_DETAIL: 'EXIT_GOODS_DETAIL',
  EXIT: 'exit',
  TO_DX_PLATFORM_VERIFY: 'toDxPlatformVerify'
}

const EXTERNAL_PLATFORM = 'isupplier'

function checkSign() {
  return iceStore.get('USER_INFO')
}

function isDataCenterExternalMode() {
  if (!isInIcestark()) return false
  return !!iceStore.get(ICE_STORE_KEYS.SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE) ||
    sessionStorage.getItem(ICE_STORE_KEYS.SUB_SYSTEM_DATA_CENTER_EXTERNAL_MODE) === 'true'
}

function getScwTokenFromIceStore() {
  return (
    iceStore.get(ICE_STORE_KEYS.SCW_TOKEN) ||
    sessionStorage.getItem(ICE_STORE_KEYS.SCW_TOKEN) ||
    ''
  )
}

/**
 * 外层鉴权模式下改写业务请求头；非该模式原样返回
 * @param {Record<string, string>} headers
 */
function applyExternalAuthHeaders(headers = {}) {
  if (!isDataCenterExternalMode()) return headers
  headers.Authorization = `Basic ${getScwTokenFromIceStore()}`
  headers.platform = EXTERNAL_PLATFORM
  return headers
}

async function getTokenAnonymous(params) {
  try {
    const { data } = await autoLogin(params)
    util.cookies.set('uuid', data.userId)
    util.cookies.set('token', data.token)
    console.log('get token from data-center : ', data.token)
  } catch (err) {
    throw err
  }
}

async function checkTokenInMicroApp(getMenu, type) {
  console.log('Check token in microapp: ', type)
  if (!isInIcestark()) return
  try {
    // 是否外层鉴权
    const isExternal = isDataCenterExternalMode()
    // 外层鉴权：跳过换票，仍可继续拉菜单/权限
    if (isExternal) {
      console.log('Skip autoLogin: data-center external mode')
    } else {
      const userInfo = checkSign()
      const params = userInfo || {}
      await getTokenAnonymous(params)
    }
    if (getMenu) {
      await store.dispatch(
        'd2admin/account/getAuth',
        { isLogin: true, jumped: true, isExternal },
        { root: true }
      )
    }
  } catch (err) {
    console.log('emit exit in checkTokenInMicroApp')
    emitExitEvent()
    throw err
  }
}

/** 触发微应用退出事件 */
export function emitExitEvent() {
  iceEvent.emit(ICE_EVENT_NAMES.EXIT)
}

/** 触发微应用到dx平台验证事件 */
export function emitToDxPlatformVerifyEvent(query) {
  iceEvent.emit(ICE_EVENT_NAMES.TO_DX_PLATFORM_VERIFY, query)
}

/** 触发微应用退出商品详情页事件 */
export function emitExitGoodsDetailEvent() {
  iceEvent.emit(ICE_EVENT_NAMES.EXIT_GOODS_DETAIL)
}

export {
  checkSign,
  getTokenAnonymous,
  checkTokenInMicroApp,
  isDataCenterExternalMode,
  getScwTokenFromIceStore,
  applyExternalAuthHeaders
}
